module.exports = __webpack_public_path__ + "static/img/lifestyle_26.0bce4a22.jpg";